import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { StyledListItemDescriptionLoader } from "./styles";

const MessageLoaderSmall = () => {
    return (
        <StyledListItemDescriptionLoader data-automation="message-loader">
            <PixelPlaceholderLoader
                width={270}
                height={14}
            />
            <PixelPlaceholderLoader
                width={230}
                height={14}
            />
        </StyledListItemDescriptionLoader>
    );
};

export default MessageLoaderSmall;
